module.exports = __webpack_public_path__ + "img/cases-brand-15-cover.63f8b037.png";